export default __webpack_public_path__ + "static/media/wood-blinds.bae06a64.jpg";